import React, { useState, useEffect } from 'react'
import Marquee from "react-fast-marquee";
import * as ctf from "contentful";
import Slider from 'react-slick';
const LogoSlider = () => {

    const [logs, setLogs] = useState([]);
    const client = ctf.createClient({
        space: "fdtw7gymput4",
        accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
    });

    useEffect(() => {
        fetchDataHome();
    }, []);

    const fetchDataHome = async () => {
        try {
            const resp = await client.getEntries({ content_type: "sliderLogo" });
            setLogs(resp.items);
        } catch (error) {
            console.log(error);
        }
    };

    const MarqueeLogo = logs[0]?.fields?.logos

    var settings = {
        dots: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };


    return (
        <div>
            {/* <Marquee> */}
            <Slider {...settings}>
                {MarqueeLogo && MarqueeLogo.map((item) => {
                    return (
                        <div>
                            <img src={`https:${item?.fields?.file?.url}`} alt="" />
                        </div>
                    )
                })}
            </Slider>
            {/* </Marquee> */}



        </div>
    )
}

export default LogoSlider